import React from 'react'
import Toaster from 'toastr';
import DisputeDetails from './disputesModalDetailsSection';
import DisputeActions from './disputeModalActions';
import DisputeComments from './disputeModalComments';
import DisputeJournal from './disputeModalJournal';
import DisputeSettlements from './disputeModalSettlementSection';
import DisputeEvidences from './disputeModalEvidenceSection';
import Modal from '../../../common/modal';
import Progress from '../../../common/progress';
import NetworkErrorDiv from '../../../common/networkErrorDiv';
import NewClaimModalContent from '../../newClaim/newClaimModalContent';
import DisputesApi from '../../../../api/DisputesApi';
import Constants from '../../../../configurations/constants';
import Messages from '../../../../configurations/messages';


class DisputeModal extends React.Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            loadingDispute: 1,
            performingAction: 0,
            actions: [],
            dispute: this.props.dispute,
            comment: '',
            evidences: [],
            disputeTransaction: null
        };
        this.actionHandler = this.actionHandler.bind(this);
        this.commentChangeHandler = this.commentChangeHandler.bind(this);
        this.evidenceAddedHandler = this.evidenceAddedHandler.bind(this);

    }
    componentDidMount() {
        this.loadDispute();
    }
    commentChangeHandler(event) {
        this.setState({ comment: event.target.value });
    }

    evidenceAddedHandler(evidences) {
        this.setState({ evidences: evidences });
    }

    render() {
        return (
            <Modal title={`${this.state.dispute.logCode} ${this.state.disputeTransaction ? '- Reopen Dispute' : ''}`} isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose}>
                {this.state.loadingDispute === 0 && !this.state.disputeTransaction &&
                    <div>
                        <DisputeDetails dispute={this.state.dispute} />
                        {this.state.dispute.settlementDetailsAvailable && <DisputeSettlements logCode={this.state.dispute.logCode}/>}
                        {
                            (this.state.actions.length > 0) &&
                            <DisputeComments comment={this.state.comment} onCommentChangeHandler={this.commentChangeHandler} />
                        }
                        <DisputeEvidences onEvidenceAddedHandler={this.evidenceAddedHandler} evidences={this.state.dispute.evidence} disableUpload={this.state.actions.filter(action => { return action.action === Constants.DISPUTE_ACTION_DECLINE }).length === 0} />

                        <DisputeJournal dispute={this.state.dispute} />
                        <DisputeActions actions={this.state.actions} hasCancel={true} cancelHandler={this.props.onRequestClose} disabled={this.state.performingAction === 1} />

                    </div>
                }
                {this.state.loadingDispute === 1 &&
                    <Progress />
                }
                {this.state.loadingDispute === -1 &&
                    <NetworkErrorDiv title="" description="" />
                }
                {
                    this.state.disputeTransaction &&
                    <NewClaimModalContent transaction={this.state.disputeTransaction} closeModal={this.props.onRequestClose} isDisputeReOpen={true}/>
                    
                }
            </Modal>
        )
    }

    loadDispute() {
        this.setState({ loadingDispute: 1 });
        DisputesApi.getDispute(this.state.dispute.logCode)
            .then((response) => {
                this.setState({ loadingDispute: 0, dispute: response.data });
                this.mapActions(response.data);
            })
            .catch((error) => {

                this.setState({ loadingDispute: -1 });
                Toaster.error(error.statusText, `${error.status} - ${Messages.ERROR_DISPUTE_FETCH_TITLE} `);
                console.log(error);
            })

    }

    loadDisputeReOpen() {
        this.setState({ performingAction: 1 });
        DisputesApi.getDisputeReOpenTransaction(this.state.dispute.logCode)
            .then((response) => {
                let transaction = response.data;
                transaction.logCode = this.state.dispute.logCode;
                this.setState({ performingAction: 0, disputeTransaction: transaction });
            })
            .catch(error => {
                this.setState({ performingAction: 0 });
                Toaster.error(error.data ? error.data.description :  error.statusText, `${error.status} - ${Messages.ERROR_DISPUTE_TRANSACTION_FETCH} `);
                console.log(error);
            })
    }

    mapActions(dispute) {
        let actions = dispute.statusActions ? dispute.statusActions : [];
        actions = actions.map((action) => {
            action.handler = this.actionHandler;
            return action;
        });
        this.setState({ actions: actions });
    }


    actionHandler(actionObject) {
        let updateParams = {};
        updateParams.action = actionObject.action;

        //TODO Validate controls/fields required for the action
        switch (actionObject.action) {
            case Constants.DISPUTE_ACTION_ACCEPT:
                updateParams.comment = this.state.comment;
                this.updateDisputeAction(updateParams);
                break;
            case Constants.DISPUTE_ACTION_COMMENT:
                if (actionObject.required.filter(field => { return field === Constants.DISPUTE_FIELD_COMMENT }).length > 0 && !this.state.comment.trim()) {
                    Toaster.error(Messages.ERROR_COMMENT_REQUIRED);
                    return;
                }
                updateParams.comment = this.state.comment;
                this.updateDisputeAction(updateParams);
                break;
            case Constants.DISPUTE_ACTION_DECLINE:
                //Evidence is a required field and No evidence files attached            
                if (actionObject.required.filter(field => { return field === Constants.DISPUTE_FIELD_EVIDENCE }).length > 0 && this.state.evidences.length === 0) {
                    Toaster.error(Messages.ERROR_EVIDENCE_REQUIRED);
                    return;
                }
                if (actionObject.required.filter(field => { return field === Constants.DISPUTE_FIELD_COMMENT }).length > 0 && !this.state.comment.trim()) {
                    Toaster.error(Messages.ERROR_COMMENT_REQUIRED);
                    return;
                }
                updateParams.comment = this.state.comment;
                updateParams.evidence = this.state.evidences;
                this.updateDisputeAction(updateParams);
                break;
            case Constants.DISPUTE_ACTION_REOPEN:
                this.loadDisputeReOpen();
                break;


        }

    }
    updateDisputeAction(params) {
        this.setState({performingAction : 1});
        DisputesApi
            .updateDispute(this.state.dispute.logCode, params)
            .then((response) => {
                Toaster.success(`${Messages.SUCCESS_DISPUTE_ACTION} - ${params.action}`, this.state.dispute.logCode);
                //Close modal
                this.props.onRequestClose(null, true);
                this.setState({performingAction : 0});
            })
            .catch((error) => {
                Toaster.error(`${Messages.ERROR_DISPUTE_ACTION} -  ${params.action} - ${error.statusText}`, this.state.dispute.logCode)
                //TODO Flag invalid fields if bad request
                console.log(error);
                this.setState({performingAction : 0});

            });
    }



}

export default DisputeModal;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModal.js